import { createSlice } from "@reduxjs/toolkit";
import { ICourseRateDetailSlice } from "../../../models/student/studentCourceDetail";

const InitialCourceRateDetails: ICourseRateDetailSlice = {
    rateDetail: undefined,
};

const studentCourceRateDetailSlice = createSlice({
    name: "studentCourceRateDetail",
    initialState: InitialCourceRateDetails,
    reducers: {
        setCourceRateDetail: (state, action: { payload: any }) => {
            state.rateDetail = action.payload;
        },
    },
});

export const { setCourceRateDetail } = studentCourceRateDetailSlice.actions;

const studentCourceRateDetailReducer = studentCourceRateDetailSlice.reducer;

export type studentCourceRateDetailState = ReturnType<typeof studentCourceRateDetailReducer>;

export default studentCourceRateDetailReducer;



